export default "__VITE_ASSET__BHAQXMDe__"